import React from "react";
import { useNavigate } from 'react-router-dom';

import imageOne from '../resource/aboutus/F1..png'
import imageOtwo from '../resource/aboutus/F1.png'
import imageThree from '../resource/aboutus/F2.png'
import imageFour from '../resource/aboutus/L1 (2).png'
import imageFive from '../resource/aboutus/L2 (2).png'
import imageSix from '../resource/aboutus/L5 (2).png'
import imageSeven from '../resource/aboutus/L4 (2).png'
import imageEight from '../resource/aboutus/L3(2).png'
import imageNine from '../resource/aboutus/F3.png'

import '../css/common.css'


import TitleChnage from "../Hook/TitleChnage";

const AboutUs = () => {
    const navigate = useNavigate();
    TitleChnage("About Us")

    const handleClick = (event) => {
        const pathMap = {
            history: '/history',
            teacher: '/teacher',
            mvideo: '/mvideo',
            mission: '/mission',
            compliment: '/compliment',
            home: '/'
        }
        
        const path = event.currentTarget.id;
        const targetPath = pathMap[path]
        
        if (targetPath) {
            navigate(targetPath)
        }
    }

    return (
        <div className="page aboutus-page-container">
            <img src={imageOne} alt="" className="left-imge-fixed" />
            <img src={imageOtwo} alt="" className="right-imge-fixed" />

            <header className="aboutus-header">
                <div className="title">
                    <h1 className="aboutus-title">About Us</h1>
                    <img src={imageThree} className="title-img" alt="" />
                </div>
            </header>

            <section className="intro-text-compact">
                <p className="font-second dark-gold intro-welcome">Welcome to Bhaddekha Vihari Monastery......</p>
                <div className="box">
                    <ul className="text-left intro-poem">
                        <li>Come along, embrace the peace,</li>
                        <li>Where inner calm and worries cease.</li>
                        <li>In quiet stillness, find your way,</li>
                        <li>A sanctuary where hearts can stay</li>
                    </ul>
                </div>
            </section>

            <section className="button-section-compact">
                <div className="left-col">
                    <img src={imageFour} alt="history" onClick={handleClick} id="history" className="nav-img" />
                    <img src={imageEight} alt="mission" className="nav-img" onClick={handleClick} id="mission"/>
                </div>
                <div className="middle-col">
                    <img src={imageSix} alt="video" className="nav-img" onClick={handleClick} id="mvideo"/>
                </div>
                <div className="right-col">
                    <img src={imageFive} alt="teacher" className="nav-img" onClick={handleClick} id="teacher"/>
                    <img src={imageSeven} alt="compliment" className="nav-img" onClick={handleClick} id="compliment" />
                </div>
            </section>

            <div className="box bottom-img-container">
                <img src={imageNine} alt="" className="bottom-imge-fixed" />
            </div>
        </div>
    )
}

export default AboutUs